// extracted by mini-css-extract-plugin
module.exports = {"container":"container_1blNX","detailImageContainer":"detailImageContainer_5MvEk container_1blNX","fixed":"fixed_1wnVy"};